import TcTable from '../TcTable';
import { TABLE_HEAD, defaultFilters, tableNames } from './data';

export default function PriceListView() {
  return (
    <TcTable TABLE_HEAD={TABLE_HEAD} defaultFilters={defaultFilters} tableNames={tableNames} />
  );
}
